/** **************
 *   Setting Organization Profile
 /*************** */

import { handleAPI, API_VERSION_TWO } from 'utils/apiUtils'

export function jobTitlesLoad(params = {}) {
  const url = `/${API_VERSION_TWO}/job_titles/`
  const method = 'GET'

  return {
    type: 'JOB_TITLES_LOAD',
    payload: handleAPI(url, params, method),
  }
}

export function jobTitleLoad() {
  const url = `/${API_VERSION_TWO}/job_titles/`
  const method = 'GET'

  return {
    type: 'JOB_TITLE_LOAD',
    payload: handleAPI(url, {}, method),
  }
}

export function jobTitleCreate(data) {
  const url = `/${API_VERSION_TWO}/job_titles/`
  const method = 'POST'
  return {
    type: 'JOB_TITLE_CREATE',
    payload: handleAPI(url, {}, method, { job_title: data }),
  }
}

export function jobTitleUpdate(data) {
  const url = `/${API_VERSION_TWO}/job_titles/${data.id}/`
  const method = 'PUT'
  return {
    type: 'JOB_TITLE_UPDATE',
    payload: handleAPI(url, {}, method, { job_title: data }),
  }
}

export function jobTitleDelete(id) {
  const url = `/${API_VERSION_TWO}/job_titles/${id}/`
  const method = 'DELETE'

  return {
    type: 'JOB_TITLE_DELETE',
    payload: new Promise((resolve, reject) => {
      handleAPI(url, {}, method)
        .then((response) => {
          resolve({ id, ...response })
        })
        .catch((err) => {
          reject(err)
        })
    }),
  }
}
